document.addEventListener('DOMContentLoaded', function() {
  
   
    // Select the element to observe for changes
    const activeFacets = document.querySelector('.active-facets');

    if(activeFacets){
      // Configure the observer to watch for changes in child nodes
      const observer = new MutationObserver((mutationsList) => {
        // Iterate over the mutations recorded
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            // If a change in child nodes is detected
            if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
              console.log('Changes detected in child nodes.');
              location.reload();
            }
          }
        }
      });
      
      // Observer options to watch for changes in child nodes
      const config = { childList: true, subtree: true };
      
      // Start observing the element
      observer.observe(activeFacets, config);
      
      // Example of how to stop observing if it's no longer needed
      // observer.disconnect();
    }
});